export const FUNCTION_HUB_TEXT = {
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  EXTEND_REGISTRATION_FEE: {
    TITLE: 'Extend Registration Fee Payment Deadline',
  },
  COMMENCE_OF_STUDY: {
    TITLE: 'Confirm Commencement Date',
  },
  CHANGE_SUPERVISOR: {
    TITLE: 'Change Chief Supervisor',
    CHANGE_CHIEF: 'Change Chief Supervisor',
    REASSIGN:
      'It has been detected that the chief supervisor you wish to update is currently serving as a co-supervisor within the existing supervisory team. Would you like to reassign their role from co-supervisor to chief supervisor?',
  },
  REJECT_APPLICATION: {
    TITLE: 'Reject Application',
    EXPLANATION: 'Reject the Application',
    QUESTION: 'Do you confirm to reject this applicant?',
    NOTE: 'Once an application is rejected, it will not be processed further. A notification will be sent to the applicant to inform them of this decision.',
  },
  DECLINE_APPLICATION: {
    TITLE: 'Decline Application',
    EXPLANATION: 'Decline the Application',
    QUESTION:
      'Do you confirm to decline this applicant on behalf of the chief supervisor?',
    NOTE: 'Once an application is declined, you will no longer be able to process it as the chief supervisor. However, it may still be considered by other academic staff for the role of chief supervisor.',
  },
};

export const EXTEND_REG_FEE_DDL = {
  EXTEND_BUTTON: 'Extend',
  DIALOG: {
    EXTEND_DDL: {
      TITLE: 'Extend Registration Fee Deadline',
      CONFIRM: 'Save',
      CANCEL: 'Cancel',
      COMPONENT: {
        FROM: 'From:',
        TO: 'To:',
      },
    },
    NOTIFICATION: {
      TITLE: 'Notification',
      CONFIRM: 'Confirm',
      CANCEL: 'Cancel',
      COMPONENT: {
        CONFIRM_MSG:
          'Do you firm to extend registration fee payment deadline for this applicant?',
      },
    },
  },
  ALERT: {
    SUCCESS: 'Successfully Extended the Deadline.',
    ERROR: 'Error Occurs.',
  },
};

export const COMMENCE_OF_STUDY = {
  CONFIRM: 'Confirm Date',
  DIALOG: {
    CONFIRM_DATE: {
      TITLE: 'Confirm a commencement date',
      CONFIRM: 'Save',
      CANCEL: 'Cancel',
      COMPONENT: {
        REPORTED_DATE: 'Reported Date:',
      },
    },
    NOTIFICATION: {
      TITLE: 'Notification',
      CONFIRM: 'Confirm',
      CANCEL: 'Cancel',
      COMPONENT: {
        CONFIRM_MSG: 'Do you confirm the commencement date of the study?',
      },
    },
  },
  ALERT: {
    SUCCESS: 'Successfully Updated the Commencement Date.',
    ERROR: 'Error Occurs.',
  },
};
